import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Box, Typography } from '@mui/material';
 
interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  height?: number | string;
  minHeight?: number | string;
  readOnly?: boolean;
  toolbarItems?: string[];
}
 
const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  label,
  placeholder = 'Start typing...',
  height = 'auto',
  minHeight = 300,
  readOnly = false,
  toolbarItems = [
    'heading',
    '|',
    'bold',
    'italic',
    'underline',
    'link',
    'bulletedList',
    'numberedList',
    'blockQuote',
    '|',
    'undo',
    'redo'
  ],
}) => {
  return (
    <Box width="100%">
      {label && (
        <Typography variant="subtitle1" fontWeight={600} gutterBottom color="text.primary">
          {label}
        </Typography>
      )}
      <Box
        sx={{
          border: '1px solid #ddd',
          borderRadius: 2,
          p: 2,
          backgroundColor: readOnly ? '#f5f5f5' : '#fafafa',
          transition: 'border-color 0.2s, box-shadow 0.2s',
          '&:hover': {
            borderColor: readOnly ? '#ddd' : '#bbb',
          },
          '&:focus-within': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)',
          },
          '& .ck-editor__editable_inline': {
            minHeight: typeof minHeight === 'number' ? `${minHeight}px` : minHeight,
            height: typeof height === 'number' ? `${height}px` : height,
            backgroundColor: readOnly ? '#f9f9f9' : '#fff',
            padding: '16px',
            borderRadius: '4px',
          },
          '& .ck.ck-editor__main': {
            border: 'none',
          },
        }}
      >
        <CKEditor
          editor={ClassicEditor}
          data={value}
          disabled={readOnly}
          onChange={(_, editor) => onChange(editor.getData())}
          config={{
            placeholder,
            toolbar: {
              items: toolbarItems,
              shouldNotGroupWhenFull: true,
            },
          }}
        />
      </Box>
    </Box>
  );
};
 
export default RichTextEditor;